import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
export function AccordionHeader(props) {
    const { title, endElement } = props;
    return (<Box alignItems="center" justifyContent="space-between" px="md">
      <Typography $appearance="300" $fontSize="small" $fontWeight="medium">
        {title}
      </Typography>
      {endElement}
    </Box>);
}
